import Vue from 'vue'
import axios from 'axios'
import store from '../store'
//取消请求
let CancelToken = axios.CancelToken;
// 重试队列，每一项将是一个待执行的函数形式
let requests = []
//获取token
function getToken(config) {
    let initBusType = window.localStorage.getItem("initBusType"),
        initToken = window.localStorage.getItem("initToken");
    let mewtimestamp = new Date().getTime();
    window.localStorage.setItem("timestamp", mewtimestamp);
    axios.post(`/auth/permission?busType=${initBusType}&token=${initToken}`).then(res => {
        let {
            jwtToken
        } = res.data.data;
        store.commit("USERINFO", res.data.data)
        window.localStorage.setItem("token", jwtToken)
        // console.log('Authorization-jwtToken', jwtToken)
        config.headers['Authorization'] = jwtToken;
    })
}
async function awa(config) {
    await getToken(config);
}

let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let removePending = (config) => {
    for (let p in pending) {
        if (pending[p].u === config.url + '&' + config.method) { //当当前请求在数组中存在时执行函数体
            pending[p].f(); //执行取消操作
            pending.splice(p, 1); //把这条记录从数组中移除
        }
    }
}

var instance = axios.create({});

// 请求超时的时间限制和环境//axios.defaults.baseURL = process.env.BASE_API; //cross-evn.NODE_
// axios.defaults.baseURL = 'https:/im.yunduocrm.com/api/im-business'; //prd
// axios.defaults.baseURL = process.env.BASE_API; //cross-evn.NODE_
axios.defaults.baseURL='/api/im-business';
axios.defaults.timeout = 20000;
// 开始设置请求 发起的拦截处理
// config 代表发起请求的参数的实体
axios.interceptors.request.use(config => {
  console.log(config)
     let timestamp = new Date().getTime(),
       token = window.localStorage.getItem("token"),
       getTokenTimestamp = window.localStorage.getItem("timestamp");
    removePending(config); //在一个ajax发送前执行一下取消操作
    config.CancelToken = new CancelToken((c) => {
        // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
        pending.push({
            u: config.url + '&' + config.method,
            f: c
        });
    })
    if (config.isReplaceHeaders){
    }else{
      if(token){
        config.headers['Authorization'] = token;
      }
      config.headers['callMethod'] = 'page';
    }
    return config
}, error => {
    return Promise.reject(error)
})

// 请求到结果的拦截处理
axios.interceptors.response.use(config => {
    removePending(config)
    // 返回请求正确的结果
    return config
}, error => {
  console.log(error,'错误',error.response)
    // 错误的请求结果处理，这里的代码根据后台的状态码来决定错误的输出信息
    console.log(error)
    if (error && error.response) {
        switch (error.response.status) {
            case 400:
                error.message = '错误请求'
                break
            case 401:
                error.message = '401'
                localStorage.clear()
                sessionStorage.clear()
                location.href = error.response.data.data.redirectUrl + '?redirectUrl=' + encodeURIComponent(location.href)
                console.log(error.response.data.data.redirectUrl)
                break
            case 403:
                error.message = '拒绝访问'
                break
            case 404:
                error.message = '请求错误,未找到该资源'
                break
            case 502:
                error.message = '网络错误'
                break
            case 503:
                error.message = '服务不可用'
                break
            case 504:
                error.message = '网络超时'
                break
            default:
                error.message = `连接错误${error.response.status}`
        }
    } else {
        error.message = "连接到服务器失败"
    }
    return Promise.reject(error.message)
})
// 将axios 的 post 方法，绑定到 vue 实例上面的 $post
Vue.prototype.$post = function (url, params, baseUrl='') {
    return new Promise((resolve, reject) => {
      // console.log(baseUrl+url,'qiguaima')
        axios.post(baseUrl+url, params )
            .then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
    })
}
// 将axios 的 get 方法，绑定到 vue 实例上面的 $get
Vue.prototype.$get = function (url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res) // 返回请求成功的数据 data
        }).catch(err => {
            reject(err)
        })
    })
}

export default axios



// WEBPACK FOOTER //
// ./src/utils/axiosTool.js